import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { PATH_URL } from './helpers'
import { QuizType } from './pages/shared'

// Set up a property descriptor to watch for changes to window.USE_PINTEREST_FLOW
// This allows us to detect when an A/B testing tool sets this value
let usesPinterestFlow = window.USE_PINTEREST_FLOW || false

Object.defineProperty(window, 'USE_PINTEREST_FLOW', {
  configurable: true,
  enumerable: true,
  get: function () {
    return usesPinterestFlow
  },
  set: function (newValue) {
    console.log('USE_PINTEREST_FLOW changed to:', newValue)
    usesPinterestFlow = newValue

    // If set to true and we're on the homepage, redirect to Pinterest flow
    if (
      newValue === true &&
      (window.location.pathname === '/' || window.location.pathname.includes('color-palettes'))
    ) {
      console.log('Redirecting to Pinterest flow due to property change')

      // Build the URL with correct parameters
      const currentParams = new URLSearchParams(window.location.search)
      const url = new URL(PATH_URL.PINTEREST_AVAILABILITY, window.location.origin)

      // Transfer existing params
      currentParams.forEach((value, key) => {
        // Don't pass serviceabilityData to next redirect
        url.searchParams.append(key, value)
      })

      // Add quizType parameter
      url.searchParams.set('quizType', QuizType.PINTEREST)

      // Redirect to Pinterest flow
      window.location.replace(url.toString())
    }
  },
})

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()

// For testing: This function allows you to manually test the dynamic Pinterest flow redirection
// It simulates what would happen when an A/B testing tool sets window.USE_PINTEREST_FLOW
// You can call this from the browser console with: testPinterestRedirect()
;(window as any).testPinterestRedirect = () => {
  console.log('Testing Pinterest flow redirection...')
  window.USE_PINTEREST_FLOW = true
}
